import React, { FC,  useEffect, useRef, useState } from 'react';
import {  IAssessmentProject, IDam,  IError,  IProjectUser, IUpload } from "../types/types";
import { get, post, postv2, upload } from "../fetchers/fetchers";
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import DialogContentText from '@material-ui/core/DialogContentText';
import SettingsIcon from '@material-ui/icons/Settings';
import { ArrowBack } from '@material-ui/icons';
import SFIARPToolbar from '../components/toolbar';
import Dam from "./dam";
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton, List, ListItem, ListItemText,
    TextField, TextFieldProps,
    Tooltip,
    withStyles
} from "@material-ui/core";

import { useHistory } from "react-router-dom";
import { CloudUpload } from "@material-ui/icons";
import { useParams } from "react-router";
import { API_URL } from "../env";


interface IDamsProps {
}

interface IRouteParams {
    id: string
}



const AddingButton = withStyles(theme => ({
    root: {
        margin: "auto",
        backgroundColor: "rgba(0,103,114,0.2)",
        color: "rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);



const Dams: FC<IDamsProps> = () => {

    const history = useHistory();

    const params = useParams<IRouteParams>()
    const [dams, setDams] = useState<IDam[]>([]);
    const [reload, setReload] = useState<boolean>(true);
    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const [openFileUpload, setOpenFileUpload] = useState<boolean>(false);
    const [uploadConfirmed, setUploadConfirmed] = useState<boolean>(false);
    const newProjectName = useRef<TextFieldProps>(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [errorLogs, setErrorLogs] = useState<IError[]>([]);
    const [fileID, setFileID] = useState<IUpload>();
    const [uploadedDam, setUploadedDam] = useState<IDam | undefined>(undefined);

    const [projectAccessLevel, setProjectAccessLevel] = useState<number>(0);

    const uploadFile = async (file: any) => {
        const d = await upload<IUpload>(API_URL + "upload/", file);
        setFileID(d)
    }

    const handleCapture = ({ target }: any) => {
        let formData = new FormData();
        formData.append("file", target.files[0]);
        uploadFile(formData).then(() => setSelectedFile(target.files[0].name))
    };

    const getData = async () => {
        const d = await get<IDam[]>(API_URL + "dams/" + params.id);
        setDams(d)
    }

    const getProjectAccessLevel = async () => {
        const d = await get<IProjectUser>(API_URL + "projects/" + params.id + "/my_role");
        setProjectAccessLevel(d.access_level)
    }

    const addDam = async (dam: IDam) => {
        await post<IDam>(API_URL + "dams/" + params.id, dam);
        setReload(true)
    }

    const handleClose = () => {
        setOpenCreateDialog(false)
    }

    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const handleDashboardRedirect = () => {
        history.push('/dashboard/' + params.id);
    }

    const handlePrioritisationRedirect = () => {
        history.push('/prioritisation/' + params.id);
    }


    const handleOpenFileUpload = () => {
        setOpenFileUpload(true)
    }
    const handleCloseFileUpload = () => {
        setErrorLogs([])
        setOpenFileUpload(false)
    }

    const createDam = () => {
        let projectName = newProjectName.current?.value as string
        addDam({ id: 0, name: projectName, is_active: true }).then(() => setOpenCreateDialog(false))

    }

    const addTemplate = async () => {

        if (fileID) {
            return await postv2<IUpload, IAssessmentProject>(API_URL + "template_import/" + params.id, {
                uuid: fileID.uuid,
                name: fileID.name,
                document_id: -1
            });
        }
    }

    const confirmUpload = () => {
        setUploadConfirmed(false)
        setReload(true)
        setOpenFileUpload(false)

        if (uploadedDam) {
            addDam({ id: uploadedDam?.id, name: uploadedDam?.name, is_active: true })
        }


    }

    const handleSettings = () => {
        history.push("/admin/" + params.id)
    }

    const handleBack = () => {
        history.push("/")
    }
    const uploadTemplate = () => {
        if (fileID) {
            addTemplate().then((assessment) => {

                setUploadConfirmed(true)
                setSelectedFile(null)
                setUploadedDam(assessment?.dam)
                if (assessment?._errors) {
                    setErrorLogs(assessment._errors)
                }
            })
        }
    }

    useEffect(() => {

        if (reload) {
            getData().then(() => setReload(false)).catch((e) => {
                history.push("/login");
            })
        }
        getProjectAccessLevel().then(() => {
        })
    }, [reload])

    const create_upload_dialog = () => {
        return (
            <Dialog open={openFileUpload} onClose={handleCloseFileUpload} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Upload Assessment Template</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Upload Assessment Template.
                        </Typography>

                        <p />
                        {!selectedFile && <div>
                            <input
                                accept=".xlsb"
                                id="icon-button-upload"
                                type="file"
                                hidden
                                onChange={handleCapture}
                            />

                            <label htmlFor="icon-button-upload">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    startIcon={<CloudUpload />}
                                >
                                    Upload
                                </Button>
                            </label>

                        </div>}
                        {selectedFile && <div>
                            {selectedFile}
                        </div>}
                        <p />

                        <List dense={true}>

                            {errorLogs.map((e) => {
                                return (
                                    <ListItem>
                                        <ListItemText
                                            primary={e.error}
                                        />
                                    </ListItem>)
                            })}
                        </List>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseFileUpload} color="primary">
                        Cancel
                    </Button>
                    {selectedFile && <Button onClick={uploadTemplate} color="primary">
                        Submit
                    </Button>}
                    {uploadConfirmed && <Button onClick={confirmUpload} color="primary">
                        Confirm
                    </Button>}
                </DialogActions>
            </Dialog>
        )
    }

    return (

        <>
        <SFIARPToolbar title={"Assessments"}/>

        <Container>
            <Dialog open={openCreateDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Create Dam</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        To add a new dam to the SFAIRP Assessment please enter the name of the dam.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Dam name"
                        type="text"
                        fullWidth
                        inputRef={newProjectName}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={createDam} color="primary">
                        Create
                    </Button>
                </DialogActions>
            </Dialog>

            {create_upload_dialog()}

            <Grid container spacing={3} xl={12} direction="row" style={{ padding: "20px", marginTop: "40px" }}>
                <Grid item xs={5} sm={3} md={2} lg={2}>
                    <div style={{ position: "sticky", top: "68px" }}>
                        <Tooltip title="Back" placement={'bottom-end'}>
                            <AddingButton style={{ backgroundColor: "rgb(239,88,43)", color: "#FFFFFF" }} onClick={prevState => handleBack()} >
                                <ArrowBack />
                            </AddingButton>
                        </Tooltip>
                        <br />
                        { projectAccessLevel >=3 && <Tooltip title="Create new project" placement={'bottom-end'}>
                            <AddingButton style={{ backgroundColor: "rgb(239,88,43)", color: "#FFFFFF" }} onClick={prevState => handleOpen()} >
                                <AddIcon />
                            </AddingButton>
                        </Tooltip> }
                        <br /> 
                        { projectAccessLevel >=3  && <Tooltip title="Upload excel template" placement={'bottom-end'}>
                            <IconButton color="primary" component="span"
                                style={{
                                    margin: "auto",
                                    backgroundColor: "rgb(239,88,43)",
                                    color: "rgb(255,255,255)"
                                }} onClick={() => handleOpenFileUpload()}>
                                <CloudUpload />
                            </IconButton>
                        </Tooltip> }
                        <br />
                        <Tooltip title="View dashboard" placement={'bottom-end'}>
                            <IconButton color="primary" component="span"
                                style={{
                                    margin: "auto",
                                    backgroundColor: "rgb(239,88,43)",
                                    color: "rgb(255,255,255)"
                                }} onClick={() => handleDashboardRedirect()}>
                                <ViewModuleIcon />
                            </IconButton>
                        </Tooltip>
                        <br />
                        <Tooltip title="View prioritisation" placement={'bottom-end'}>
                            <IconButton color="primary" component="span"
                                style={{
                                    margin: "auto",
                                    backgroundColor: "rgb(239,88,43)",
                                    color: "rgb(255,255,255)"
                                }} onClick={() => handlePrioritisationRedirect()}>
                                <ClearAllIcon />
                            </IconButton>
                        </Tooltip>
                        <br />
                        { projectAccessLevel >=4  && <Tooltip title="Settings" placement={'bottom-end'}>
                            <AddingButton style={{ backgroundColor: "rgb(239,88,43)", color: "#FFFFFF" }} onClick={prevState => handleSettings()} >
                                <SettingsIcon />
                            </AddingButton>
                        </Tooltip>}
                        <br />
                    </div>
                </Grid>
                <Grid item xs={7} sm={9} md={9} lg={10} container spacing={3}>

                    {dams.map(d => {
                        if (d.is_active) {
                            return (<Dam dam={d} updateDam={addDam} projectAccessLevel={projectAccessLevel} />)
                        }
                    })}

                </Grid>
            </Grid>
        </Container>
        </>
    );
    
};

export default Dams;

